document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".slideshow");

  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll(".slideshow__slide");
    if (slides.length <= 1) return;

    let index = 0;

    function showSlide(i) {
      slides.forEach((slide, idx) => {
        slide.style.display = idx === i ? "block" : "none";
      });
    }

    function nextSlide() {
      index = (index + 1) % slides.length;
      showSlide(index);
    }

    // init
    showSlide(index);

    // autoplay (5 seconds)
    setInterval(nextSlide, 5000);
  });
});